import { LOGOUT_REQUEST, LOGOUT_SUCCESS, LOGOUT_FAILURE } from "constants";

const logoutRequest = () => {
    return {
        type:LOGOUT_REQUEST
    }
}

const logoutSuccess = () => {
    return {
        type:LOGOUT_SUCCESS
    }
}

const logoutFailed = () =>{
    return{
        type: LOGOUT_FAILURE
    }
}

export const logout = (redirect) => (dispatch) =>{

    try{
        dispatch(logoutRequest());
        localStorage.clear()
        window.sessionStorage.clear();

        dispatch(logoutSuccess());
    }catch(e){
        console.log(e);
        dispatch(logoutFailed());
    }
    redirect();
}